import type { NextPage } from "next";
import { WrapOnlyV2 } from "@components/WrapOnly";
import useLedgerCookies from "@hooks/useLedgerCookies";

const WrapPage: NextPage = () => {
  useLedgerCookies();
  return <WrapOnlyV2 />;
};

export default WrapPage;
